import { useMutation } from 'Data/Api.js'
import { notifyError, useNotifications } from 'Logic/Notifications.js'
import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'
import { useDataValue } from 'Simple/Data.js'
import addMonths from 'date-fns/addMonths'
import formatISO from 'date-fns/formatISO'
import parseISO from 'date-fns/parseISO'

import mutation from './mutation.graphql.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let tx_id = useDataValue({
    context: 'treatment_card',
    path: 'txs._id',
    viewPath: props.viewPath,
  })
  let [, notify] = useNotifications()
  let setFlowTo = useSetFlowTo(props.viewPath)
  let [, executeMutation] = useMutation(mutation)

  return async function onSubmit({ value, originalValue, args, change }) {
    if (!value.start_date || !isTreatmentLengthValid(value.length_in_months)) {
      return true
    }

    let start = parseISO(value.start_date)
    let end = addMonths(start, value.length_in_months)

    let mutationResponse = await executeMutation({
      tx_id,
      start_date: formatISO(start, { representation: 'date' }),
      end_date: formatISO(end, { representation: 'date' }),
    })

    if (mutationResponse.error) {
      return notify(
        notifyError(`Cannot update treatment's length. Please try again.`)
      )
    }

    setFlowTo(normalizePath(props.viewPath, '../No'))
  }
}

function isTreatmentLengthValid(length_in_months) {
  return !!length_in_months && length_in_months > 0 && length_in_months <= 1200
}
